import { Action, Dispatch, bindActionCreators } from 'redux';
import { ProviderCreate, StateProps, DispatchProps } from '../components/provider/ProviderCreate';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';
import { toast } from '../redux/message/actions';

export function mapStateToProps(state: RootState): StateProps {
  return {
    markets: state.markets.markets,
    services: state.serviceOffering.services,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators({ onPageDidMount, onPageWillUnmount, toast }, dispatch),
  };
}

export const ProviderCreateContainer = connect<StateProps, DispatchProps, any, RootState>(mapStateToProps, mapDispatchToProps)(ProviderCreate);
